module.exports = __webpack_public_path__ + "bed-prizes.0ee10ec7.png";